<!--
 * @Description:
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-05-13 14:59:29
 * @LastEditors: chen wei
 * @LastEditTime: 2020-05-25 16:21:03
 -->
<template>
  <div class="vip">
    <van-popup :value="show"
      :close-on-click-overlay="false"
      class="noBg">
      <div class="vip-box">
        <img class="img"
          src="./images/getvip.png">
        <div class="title">{{ title }}</div>
        <div class="msg">赠送您7天全优会员！尊享会员高端功能！</div>
        <van-button round
          type="info"
          @click="getVip">立即领取</van-button>
        <div class="close">
          <van-icon @click="close"
            :name='require("./images/icon-close.png")'
            size="28" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'GetVipTip',
  props: {
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    getVip() {
      this.$emit('getVip')
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="less" scoped>
.vip {
  .noBg {
    background: transparent;
    .vip-box {
      position: relative;
      .img {
        width: 293px;
        height: 324px;
      }
      .title {
        position: absolute;
        top: 46px;
        left: 0;
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        color: #eccb8a;
      }
      .msg {
        position: absolute;
        top: 205px;
        left: 0;
        width: 100%;
        font-size: 14px;
        font-weight: 400;
        color: rgba(236, 203, 138, 1);
        line-height: 20px;
        text-align: center;
        text-shadow: 0px 0px 14px rgba(69, 70, 74, 0.46);
      }
      /deep/ .van-button {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 255px;
        width: 188px;
        height: 40px;
        background: linear-gradient(45deg, rgba(243, 225, 187, 1) 0%, rgba(233, 194, 119, 1) 100%);
        box-shadow: 0px 0px 14px 0px rgba(69, 70, 74, 0.46);
        font-size: 16px;
        border: 0;
        font-weight: bold;
        color: rgba(63, 71, 85, 1);
        line-height: 22px;
        text-shadow: 0px 0px 14px rgba(69, 70, 74, 0.46);
      }
      .close {
        margin-top: 35px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
